import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../lib/api';
import { kr, dato } from '../lib/format';
import { PageHeader, Card } from '../components/ui';
import { Plus, Eye, Trash2, FileCheck, ClipboardList, Check, X } from 'lucide-react';

const StatusBadge = ({ s }) => {
  const map = {
    utkast:     'badge-neutral',
    sendt:      'badge-purple',
    akseptert:  'badge-success',
    avslatt:    'badge-danger',
    konvertert: 'badge-info',
  };
  return <span className={`badge ${map[s] || 'badge-neutral'}`}>{s || '–'}</span>;
};

const Tilbud = () => {
  const [liste, setListe] = useState(null);
  const nav = useNavigate();

  const last = () => api.get('/tilbud').then((r) => setListe(r.data));
  useEffect(() => { last(); }, []);

  const settStatus = async (t, status) => {
    await api.post(`/tilbud/${t.id}/status`, { status });
    last();
  };
  const konverter = async (t) => {
    if (!window.confirm(`Konverter tilbud ${t.fakturanummer} til faktura?`)) return;
    try {
      const r = await api.post(`/tilbud/${t.id}/konverter`);
      nav(`/faktura/${r.data.id}`);
    } catch (e) { alert(e.response?.data?.error || 'Feil.'); }
  };
  const slett = async (t) => {
    if (!window.confirm(`Slett tilbud ${t.fakturanummer}?`)) return;
    try { await api.delete(`/tilbud/${t.id}`); last(); }
    catch (e) { alert(e.response?.data?.error || 'Feil.'); }
  };

  if (!liste) return <span className="fm-text-muted">Laster…</span>;

  return (
    <>
      <PageHeader
        title="Tilbud"
        subtitle="Lag, send og konverter til faktura"
        actions={<button className="btn-primary" onClick={() => nav('/tilbud/ny')}>
          <Plus size={14} /> Nytt tilbud
        </button>}
      />
      <Card style={{ padding: 0 }}>
        <table>
          <thead>
            <tr>
              <th>Tilbud#</th><th>Kunde</th><th>Dato</th><th>Gyldig til</th><th>Status</th>
              <th style={{ textAlign: 'right' }}>Total</th>
              <th style={{ width: 180 }}></th>
            </tr>
          </thead>
          <tbody>
            {liste.length === 0 && (
              <tr><td colSpan={7} className="fm-text-muted" style={{ textAlign: 'center', padding: 20 }}>
                Ingen tilbud enda. Lag ett for å sende et prisestimat før faktura.
              </td></tr>
            )}
            {liste.map((t) => (
              <tr key={t.id}>
                <td>
                  <Link to={`/tilbud/${t.id}`} style={{ color: 'var(--theme-accent)', textDecoration: 'none' }}>
                    {t.fakturanummer}
                  </Link>
                </td>
                <td>{t.kunde_navn}</td>
                <td>{dato(t.dato)}</td>
                <td>{t.gyldig_til ? dato(t.gyldig_til) : '–'}</td>
                <td><StatusBadge s={t.tilbud_status} /></td>
                <td style={{ textAlign: 'right' }}>{kr(t.sum_ink_mva)}</td>
                <td>
                  <div className="flex" style={{ gap: 4 }}>
                    <Link to={`/tilbud/${t.id}`} className="btn-ghost" title="Vis"><Eye size={12} /></Link>
                    <button className="btn-ghost" onClick={() => settStatus(t, 'sendt')} title="Merk sendt">
                      <ClipboardList size={12} />
                    </button>
                    <button className="btn-ghost" onClick={() => settStatus(t, 'akseptert')}
                            title="Merk akseptert" style={{ color: 'var(--theme-success)' }}>
                      <Check size={12} />
                    </button>
                    <button className="btn-ghost" onClick={() => settStatus(t, 'avslatt')}
                            title="Merk avslått" style={{ color: 'var(--theme-danger)' }}>
                      <X size={12} />
                    </button>
                    <button className="btn-primary" onClick={() => konverter(t)}
                            title="Konverter til faktura"
                            disabled={t.konvertert_til_id}
                            style={{ padding: '2px 6px', fontSize: 11 }}>
                      <FileCheck size={12} /> Faktura
                    </button>
                    <button className="btn-ghost" onClick={() => slett(t)}
                            title="Slett" style={{ color: 'var(--theme-danger)' }}
                            disabled={t.konvertert_til_id}>
                      <Trash2 size={12} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </>
  );
};

export default Tilbud;
